import { render, staticRenderFns } from "./ConfigTimeElement.vue?vue&type=template&id=22582ba4&scoped=true&"
import script from "./ConfigTimeElement.vue?vue&type=script&lang=js&"
export * from "./ConfigTimeElement.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTimeElement.vue?vue&type=style&index=0&id=22582ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22582ba4",
  null
  
)

export default component.exports